import classnames from "classnames";
import React from "react";

const Loading = ({ isLocal, isLoading }) => {
  return (
    <div
      className={classnames(
        "loading-overlay",
        isLocal && "loading-overlay--local",
        isLoading && "is-visible"
      )}
    >
      <i className="fa fa-spinner fa-spin fa-fw fa-2x"></i>
    </div>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./components/shared/Loading.js